import React from 'react'
import PropTypes from 'prop-types'

export const DownloadMosaicTemplate = ({ onClick }) => {
  return (
    <button
      type='button'
      className='btn green-haze'
      onClick={onClick}
      style={{ width: '100%', display: 'block' }}
    >
      <i className='fa fa-download' />
      Download HTML template
    </button>
  )
}

DownloadMosaicTemplate.propTypes = {
  onClick: PropTypes.func
}

export default DownloadMosaicTemplate



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/add-to-mosaic/mosaic/components/download-mosaic-template/index.js